import React, { useState, useEffect } from 'react';
import { PageMetaLoaderProps, PageMeta } from '../types';
import SeoHead from './SeoHead';

const PageMetaLoader: React.FC<PageMetaLoaderProps> = ({ pageUrl }) => {
  const [pageData, setPageData] = useState<PageMeta | null>(null);

  useEffect(() => {
    fetch('/data/pages.json')
      .then((response) => response.json())
      .then((data: PageMeta[]) => {
        const matchedPage = data.find((page: PageMeta) => page.url === pageUrl);
        if (matchedPage) {
          setPageData(matchedPage);
        }
      })
      .catch((error) => console.error('Error loading page metadata:', error));
  }, [pageUrl]);

  if (!pageData) {
    return null;
  }

  const path = pageUrl === 'home' ? '/' : `/${pageUrl}`;

  return (
    <SeoHead
      title={pageData.title}
      description={pageData.description}
      keywords={pageData.keywords}
      path={path}
    />
  );
};

export default PageMetaLoader;
